import React, { useState } from "react";
import MainLogo from "../../assets/images/AstraLogo.svg";
import SetupWizard from "../../assets/images/SetupWizard.svg";
import quickSetup from "../../assets/images/quickSetup.svg";
import { Link, useNavigate } from "react-router-dom";
import { setQuickSetup } from "../../shared/_services/auth.services";

const Welcome = () => {
  const [showQuickStart, setShowQuickStart] = useState(false);
  const navigate = useNavigate();

  const handleShowQuickStart = () => {
    setShowQuickStart(true);
  };

  const handleQuickStart = async () => {
    try {
      const currentUserStr = localStorage.getItem("currentUser");
      if (currentUserStr) {
        const currentUser = JSON.parse(currentUserStr);
        const userId = currentUser?.user?._id;
        if (userId) {
          const response = await setQuickSetup(userId, true);
          if (response?.status === 200 || response?.status === 201) {
            // Update localStorage after successful API call
            if (currentUser && currentUser.user) {
              const updatedUser = {
                ...currentUser,
                user: {
                  ...currentUser.user,
                  quickSetup: true
                }
              };
              localStorage.setItem("currentUser", JSON.stringify(updatedUser));
            }
          }
        }
      }
    } catch (error) {
      console.error("Error in handleQuickStart:", error);
    }
    navigate("/q1");
  };

  return (
    <>
      <div className="package-payment-wrap package-page place-content-center">
        <div className="package-logo text-center">
          <img className="package-payment-logo" src={MainLogo} alt="Main Logo" />
        </div>

        <>
          {/* WELCOME SCREEN */}
          {!showQuickStart && (
            <div className="welcome-content-box">
              <h2 className="text-center package-page-heading text-light mb-3 mt-5">
                Let’s get you connected to your advisor
              </h2>

              <p className="text-center text-light mb-5">
                This quick setup helps your advisor understand your goals and give you guidance that fits your life.
                <br />
                It takes about 5 minutes. You can skip anything —you can always finish later with your advisor.
              </p>

              <button
                className="as-btn-secondary mt-4 mb-3 d-flex place-items-center mx-auto"
                onClick={handleShowQuickStart}
              >
                Let's Get Started&nbsp;&nbsp;
                <i className="iconoir-arrow-right"></i>
              </button>

              <p className="text-center">
                <Link className="text-light text-underline" to="/dashboard">
                  <u>Skip to Dashboard</u>
                </Link>
              </p>
            </div>
          )}

          {/* QUICK START CHOICE */}
          {showQuickStart && (
            <div className="quick-start-choice">
              <h2 className="text-center package-page-heading text-light mb-5 mt-5">
                <span
                  style={{ paddingRight: 15, color: "#fff", cursor: "pointer" }}
                  onClick={() => setShowQuickStart(false)}
                >
                  <i className="iconoir-arrow-left"></i>
                </span>
                How do you want to get started?
              </h2>

              <div className="container">
                <div className="row justify-content-md-center">
                  <div className="col-md-5 text-center setup-coice-card py-3" onClick={handleQuickStart} style={{ cursor: 'pointer' }}>
                    <img className="setup-wizard-img w-50 mb-3" src={quickSetup} alt="Quick Setup" />
                    <h4 className="text-light f-600">Quick Start (2 minutes)</h4>
                    <p className="text-light">
                      Skip the detailed questions and let your advisor walk you through everything.
                    </p>
                  </div>

                  <Link to="/q1" className="col-md-5 text-center setup-coice-card py-3">
                    <img className="setup-wizard-img w-50 mb-3" src={SetupWizard} alt="Full Setup" />
                    <h4 className="text-light f-600">Full Setup (3–5 minutes)</h4>
                    <p className="text-light">
                      Give your advisor helpful info upfront to personalize guidance faster.
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </>

      </div>
    </>
  );
};

export default Welcome;